import { Component, Inject, OnInit, Optional } from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';


interface PartialResponse {
  status(code: number): this;
}


@Component({
  selector: 'app-not-found',
  template: `
  <span class="main-content-feed center">
    <div class="" style="flex-direction: column;">
        <img class="no-polls-found" src="./assets/not-found.png" />
        <p class="center" style="font-weight: 700; font-size: 30px; color: #FFBC00;">Error 404</p>

        <p class="center" style="font-weight: 500; font-size: 19px; color: rgba(14, 14, 14, 0.58);">Something’s not right.</p>
        <p class="" style="padding-left: 20px; padding-right: 20px; font-weight: 500; font-size: 17px; color: rgba(14, 14, 14, 0.58); text-algin: center;">This link is like your heart when your ex becomes hotter. Sorry!</p>

        </div>
</span>
  `,
})
export class NotFoundComponent implements OnInit {
  constructor(
    @Optional() @Inject(RESPONSE) private response: PartialResponse,
  ) { }

  ngOnInit(): void {
    // if (this.response) {
    //   this.response.status(308);
    // }
  }
}
